// extracted by mini-css-extract-plugin
export default {"l":"_9a991c3ad9"};